import "./follow.css"

export default function Follow() {
  return (
    <div className="follow">Follow: <a className="github" href="https://freaky.rene-huber.eu/" target={"blank"}>NFT</a> / <a className="github" href="https://github.com/rene-huber" target={"blank"}>GitHub</a> / 
    <a className="twt" href="https://twitter.com/elfrito" target={"blank"}>Twit</a> / <a className="insta" href="https://www.instagram.com/renehuber_/" target={"blank"}>Insta</a></div>
  )
}
